"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
import ShopRiskLogSearchForm from "./search/ShopRiskLogSearchForm.vue";
import { UiFormController } from "@/components/form/UiForm.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import Question from "@/components/Question.vue";
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.operator_name = null;
    this.expiryDate = [];
    this.shop_name = null;
    this.ip = null;
    this.account = null;
    this.type = null;
  }
}
let ShopRiskLogs = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/shops/login_message_log")
    );
    this.searchStr = "";
    this.searchDate = [
      // new Date().setMonth(new Date().getMonth() - 3),
      new Date(new Date().getTime() - 3600 * 1e3 * 24 * 7),
      new Date()
    ];
    this.searchStr_dates = {};
    this.searchDate_dates = {};
    this.searchParams = {
      search: {},
      select: null
    };
    this.formcontroller = new FormController();
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(
              new Date(start.setMonth(start.getMonth() - 1)).setDate(1)
            );
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(
          new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1
        ) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = {
          operator_name: searchStr
        };
        this.searchAllData();
        return;
      }
      if (searchStr === null || searchStr === "") {
        this.searchStr_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchByDate = _.debounce((searchDate) => {
      if (searchDate !== null && searchDate.length !== 0) {
        let mintime = Date.parse(searchDate[0]);
        let maxtime = Date.parse(searchDate[1]);
        this.searchDate_dates = {
          start_time: mintime,
          end_time: maxtime
        };
        this.searchAllData();
        return;
      }
      if (searchDate === null || searchDate.length === 0) {
        this.searchDate_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchAllData = _.debounce(() => {
      this.gridController.query.current = 1;
      this.clearDrawer();
      this.searchParams = {
        search: {},
        select: null
      };
      if (this.searchDate_dates !== null) {
        this.searchParams.search = this.searchDate_dates;
        if (this.searchStr_dates !== null) {
          let obj = __spreadValues(__spreadValues({}, this.searchDate_dates), this.searchStr_dates);
          this.searchParams.search = obj;
        }
      }
      if (this.searchDate_dates === null) {
        this.searchParams = {
          search: {},
          select: null
        };
        if (this.searchStr_dates !== null) {
          this.searchParams.search = this.searchStr_dates;
        }
      }
      this.gridController.query.params = this.searchParams;
      this.gridController.search();
    }, 500);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.params = this.searchParams;
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.params = this.searchParams;
      yield this.gridController.search();
    });
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams.search = query.params;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      console.log(this.gridController.query.filter);
      yield this.gridController.search();
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      yield this.clearSearch();
      const _advancedSearchForm = ShopRiskLogSearchForm.create(
        this.formcontroller
      );
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  clearSearch() {
    return __async(this, null, function* () {
      if (this.searchStr !== "" && this.searchStr !== null || this.searchDate !== null && this.searchDate.length > 0) {
        this.searchStr = "";
        this.searchDate = [];
        this.clearDrawer();
        yield this.gridController.search();
      }
    });
  }
  clearDrawer() {
    this.formcontroller = new FormController();
    this.gridController.query.params = {
      search: {},
      select: null
    };
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  exportList() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(
          this.$t("export_tip.export_info_content"),
          this.$t("export_tip.export_info_title"),
          {
            cancelButtonText: this.$t("export_tip.export_cancel"),
            confirmButtonText: this.$t("export_tip.export_confirm")
          }
        );
        const exportWin = window.open("", "_self");
        const response = yield API.get(
          `api://base.auth/api/v7/export/shop_risk_logs`,
          {
            params: {
              page: this.gridController.query.current,
              size: this.gridController.query.size,
              sort: this.gridController.query.sort,
              search: this.gridController.query.params.search
            }
          }
        );
        exportWin.location.href = response.data.download;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
ShopRiskLogs = __decorateClass([
  Component({
    components: {
      UiGrid,
      Question
    }
  })
], ShopRiskLogs);
export {
  ShopRiskLogs as default
};
